<template>
  <v-col cols="12" md="12" xl="12" class="py-0 my-2">
    <div v-if="showHeader" class="d-flex align-center mt-1">
      <!-- <span v-if="taskWeekday === 'monday'" class="caption line-height-90">
        week from {{ taskDay }} to {{ taskDay + 7 }}
      </span> -->
      <v-divider class="my-4"></v-divider>
    </div>
    <v-row>
      <v-col
        cols="2"
        class="d-flex flex-column align-center justify-start py-0"
      >
        <template v-if="showHeader">
          <span
            class="overline m-0 py-0"
            :class="task.id === 'TODAY' ? 'red--text' : ''"
            >{{ taskMonth }}</span
          >
          <span
            class="headline font-weight-bold my-0 py-0 line-height-90"
            :class="task.id === 'TODAY' ? 'red--text' : ''"
            >{{ taskDay }}</span
          >
          <span
            class="overline m-0 py-0"
            :class="task.id === 'TODAY' ? 'red--text' : ''"
            >{{ taskWeekday }}</span
          >
        </template>
      </v-col>

      <v-col>
        <v-card
          v-if="task.id === 'TODAY'"
          class="py-2 pt-3 red--text"
          elevation="0"
        >
          <v-card-title class="my-0 py-0 font-weight-bold">
            TODAY
          </v-card-title>
        </v-card>
        <v-card v-else class="px-4 py-2" outlined>
          <v-card-title
            class="my-0 py-0 px-0 font-weight-bold pointer"
            @click="isActive = !isActive"
          >
            <v-icon class="ma-2" :color="calcColor()" :left="true">{{
              statusIcon.icon
            }}</v-icon>
            {{ task.name }}
            <v-spacer></v-spacer>
            <v-fade-transition>
              <v-chip
                v-if="task.subtype === 'maintenance'"
                class="mx-2"
                outlined
                :color="colorType[task.subtype]"
                v-show="!isActive"
              >
                {{ $t("planner.labels.maintenance") }}
              </v-chip>
              <v-chip
                v-if="task.subtype === 'repair'"
                class="mx-2"
                outlined
                :color="colorType[task.subtype]"
                v-show="!isActive"
              >
                {{ $t("planner.labels.repair") }}
              </v-chip>
              <v-chip
                v-if="task.subtype === 'reliability'"
                class="mx-2"
                outlined
                :color="colorType[task.subtype]"
                v-show="!isActive"
              >
                {{ $t("planner.labels.reliability") }}
              </v-chip>
            </v-fade-transition>
          </v-card-title>
          <v-expand-transition>
            <div v-show="isActive">
              <v-card-subtitle>
                <v-chip
                  v-if="task.subtype === 'maintenance'"
                  class="mr-2"
                  outlined
                  :color="colorType[task.subtype]"
                >
                  {{ $t("planner.labels.maintenance") }}
                </v-chip>
                <v-chip
                  v-if="task.subtype === 'repair'"
                  class="mr-2"
                  outlined
                  :color="colorType[task.subtype]"
                >
                  {{ $t("planner.labels.repair") }}
                </v-chip>
                <v-chip
                  v-if="task.subtype === 'reliability'"
                  class="mr-2"
                  outlined
                  :color="colorType[task.subtype]"
                >
                  {{ $t("planner.labels.reliability") }}
                </v-chip>

                <v-chip
                  v-if="task.type === 'recurrent'"
                  class="ma-2"
                  outlined
                  :color="colorType[task.type]"
                >
                  {{ $t("planner.labels.recurrent") }}
                </v-chip>
                <v-chip
                  v-if="task.type === 'unique'"
                  class="ma-2"
                  outlined
                  :color="colorType[task.type]"
                >
                  {{ $t("planner.labels.onetime") }}
                </v-chip>

                <v-chip
                  v-if="task.type === 'recurrent'"
                  class="ma-2"
                  outlined
                  color="black"
                >
                  {{ $t("planner.labels.itHasToBe") }}
                  {{ timeTooltip(task.changeTime) }}
                </v-chip>
              </v-card-subtitle>
              <v-card-text>{{ task.description }}</v-card-text>
              <v-card-actions
                :class="
                  $vuetify.breakpoint.mdAndUp
                    ? 'd-flex justify-center align-center'
                    : 'd-flex justify-center align-center flex-column'
                "
              >
                <v-btn class="my-1" dark @click="goToProfile(task)">
                  {{ $t("planner.buttons.gotoTask") }}
                </v-btn>
                <template v-if="!history">
                  <v-btn class="my-1" dark @click="handleDoneToday">
                    {{ $t("planner.buttons.doneToday") }}
                  </v-btn>
                  <v-dialog
                    ref="dialog"
                    v-model="modalDone"
                    :return-value.sync="doneDate"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="my-1" dark v-bind="attrs" v-on="on">
                        {{ $t("planner.buttons.done") }}
                      </v-btn>
                    </template>
                    <v-date-picker
                      v-model="doneDate"
                      :max="new Date().toISOString().substr(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modalDone = false">
                        {{ $t("planner.buttons.cancel") }}
                      </v-btn>
                      <v-btn text color="primary" @click="handleDoneWithDate">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-dialog
                    v-if="$store.getters['auth/equipmentWrite']"
                    persistent
                    max-width="350px"
                    v-model="modalDelete"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="my-1" dark v-bind="attrs" v-on="on">
                        {{ $t("planner.buttons.delete") }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12">
                            <template v-if="task.type === 'recurrent'">
                              <v-btn
                                color="primary"
                                block
                                class="my-2 mx-0"
                                @click="handleDeleteOnlyOne"
                              >
                                {{ $t("planner.buttons.deleteOnly") }}
                              </v-btn>
                              <!-- <v-btn
                                color="primary"
                                block
                                class="my-2 mx-0"
                                @click="handleDeleteAllNext"
                              >
                                Delete all the following tasks
                              </v-btn> -->
                              <v-btn
                                color="primary"
                                block
                                class="my-2 mx-0"
                                @click="handleDeleteAllTasks"
                              >
                                {{ $t("planner.buttons.deleteAll") }}
                              </v-btn>
                            </template>
                            <v-btn
                              v-else
                              color="primary"
                              block
                              class="my-2 mx-0"
                              @click="handleDeleteOnlyOne"
                            >
                              {{ $t("planner.buttons.deleteThis") }}
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              block
                              class="mt-2 mx-0"
                              @click="modalDelete = false"
                            >
                              {{ $t("planner.buttons.cancel") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-dialog>
                </template>
              </v-card-actions>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Task",
  props: [
    "task",
    "showHeader",
    "goToProfile",
    "doneTask",
    "deleteOneTask",
    "disableTask",
    "history"
  ],
  data() {
    return {
      isActive: false,
      doneDate: null,
      modalDone: false,
      modalDelete: false,
      timeObject: [
        ["year", 31536000],
        ["month", 2592000],
        ["week", 86400 * 7],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60],
        ["second", 1]
      ],
      months: [
        this.$t("dateFormat.months.jan.long"),
        this.$t("dateFormat.months.feb.long"),
        this.$t("dateFormat.months.mar.long"),
        this.$t("dateFormat.months.apr.long"),
        this.$t("dateFormat.months.may.long"),
        this.$t("dateFormat.months.jun.long"),
        this.$t("dateFormat.months.jul.long"),
        this.$t("dateFormat.months.aug.long"),
        this.$t("dateFormat.months.sep.long"),
        this.$t("dateFormat.months.oct.long"),
        this.$t("dateFormat.months.nov.long"),
        this.$t("dateFormat.months.dec.long")
      ],
      weekdays: [
        this.$t("dateFormat.weekdays.sun.long"),
        this.$t("dateFormat.weekdays.mon.long"),
        this.$t("dateFormat.weekdays.tue.long"),
        this.$t("dateFormat.weekdays.wed.long"),
        this.$t("dateFormat.weekdays.thr.long"),
        this.$t("dateFormat.weekdays.fri.long"),
        this.$t("dateFormat.weekdays.sat.long")
      ],
      colors: {
        green: "#008450",
        yellow: "amber darken-3",
        red: "#B81D13"
      },
      colorType: {
        maintenance: "pmaintenance",
        repair: "prepair",
        reliability: "preliability",
        unique: "secondary",
        recurrent: "indigo"
      }
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
    realDate() {
      return this.task?.taskDate ? this.task.taskDate.split("-") : "00";
    },
    taskDay() {
      return this.realDate[2];
    },
    taskMonth() {
      return this.months[Number(this.realDate[1]) - 1];
    },
    taskWeekday() {
      const date = new Date(this.task.taskDate);
      return this.weekdays[date.getUTCDay()];
    },
    statusIcon() {
      const today = +new Date() / 1000;
      const date = new Date(this.task.taskDate) / 1000;

      if (today > date)
        return { icon: "mdi-alert-circle", color: this.colors.red };
      if (today > date - this.task.alertTime + 24 * 3600)
        return { icon: "mdi-alarm-light", color: this.colors.yellow };
      return { icon: "mdi-alarm-check", color: this.colors.green };
    }
  },
  methods: {
    hanldeActive() {
      this.isActive = !this.isActive;
    },
    handleDoneToday() {
      this.$emit("doneTask", this.task);
    },
    handleDoneWithDate() {
      this.$emit("doneTask", this.task, this.doneDate);
    },
    handleDeleteOnlyOne() {
      // ? Send the uniqueId and task
      this.$emit("deleteOneTask", this.task);
    },
    handleDeleteAllNext() {
      // ! This needs to be done, but first the planner needs a repetition limit
    },
    handleDeleteAllTasks() {
      // ? Send the task and disabled it
      this.$emit("disableTask", this.task);
    },
    timeTooltip(time) {
      for (const [unit, value] of this.timeObject) {
        if (time > value || unit === "seconds") {
          let timeago = Math.floor(parseFloat(time / +value));
          let finalUnit = timeago > 1 ? `${unit}s` : unit;
          return `${timeago} ${this.$t(`repairList.${finalUnit}`)}`;
        }
      }
    },
    dateTooltip(date) {
      const jsDate = new Date(date);
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };
      const lang = this.user.language ? this.user.language : "en";

      return new Intl.DateTimeFormat(lang, options).format(jsDate);
    },
    nextDateTooltip(lastChange, timeChange) {
      const jsDate = +new Date(lastChange) + timeChange * 1000;
      return this.dateTooltip(jsDate);
    },
    timeAgo(date) {
      const time = +new Date() - +new Date(date);

      const lang = this.user.language ? this.user.language : "en";
      const rtf = new Intl.RelativeTimeFormat(lang);

      const seconds = time / 1000;
      let timeago;
      for (const [unit, value] of this.timeObject) {
        if (seconds > value || unit === "seconds") {
          timeago = -Math.floor(parseFloat(seconds / +value));
          return `${rtf.format(timeago, unit)}`;
        }
      }
    },
    calcColor() {
      if (this.history === true) {
        if (this.task.subtype === "maintenance")
          return this.colorType.maintenance;
        if (this.task.subtype === "reliability")
          return this.colorType.reliability;
        if (this.task.subtype === "repair") return this.colorType.repair;
      }

      const today = +new Date() / 1000;
      const date = new Date(this.task.taskDate) / 1000;

      if (today > date) return this.colors.red;
      if (today > date - this.task.alertTime + 24 * 3600)
        return this.colors.yellow;
      return this.colors.green;
      /* if (this.task.subtype === "Mantenimientos") return this.colorType.yellow;
      if (this.task.subtype === "Confiabilidad") return this.colorType.blue;
      if (this.task.subtype === "Reparaciones") return this.colorType.orange; */
    }
  }
};
</script>

<style scoped>
.v-btn {
  margin-left: 0.5rem;
}
.pointer {
  cursor: pointer;
  word-break: unset;
}
.line-height-90 {
  line-height: 90%;
}
</style>
